import { Product as TProduct } from "@core/types";

const getLowestPriceVariation = (allVariations: Array<TProduct>): TProduct | null => {
  const instockVariations = allVariations.filter((variation) => variation.stockStatus === "instock");
  
  if (instockVariations.length > 0) {
    let lowestPriceVariation = instockVariations[0];
    instockVariations.forEach((variation) => {
      const currentPrice = Number(variation.price) || 0;
      const lowestPrice = Number(lowestPriceVariation.price) || 0;
      
      if (currentPrice > 0 && (lowestPrice === 0 || currentPrice < lowestPrice)) {
        lowestPriceVariation = variation;
      }
    });

    return lowestPriceVariation;
  }

  return null;
};

export { getLowestPriceVariation };
